module.exports = __webpack_public_path__ + "static/Kuba_1_min-b77a965301b21b50bb82017223dcbcd4.jpg";